var _excluded = ["mx", "my", "mb", "mr", "ml", "mt", "px", "py", "pb", "pr", "pl", "pt"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { css } from 'styled-components';
import { colors, margins, paddings } from './lightTheme';
export var variant = function variant(prop, variants) {
  return function (props) {
    return variants[props[prop]];
  };
};
var _boolean = function _boolean(prop, style) {
  return function (props) {
    return props[prop] && style;
  };
};
export { _boolean as boolean };
export var variantColor = function variantColor(prop, defaultValue) {
  if (prop === void 0) {
    prop = 'variantColor';
  }
  return function (props) {
    return colors[props[prop]] || props[prop] || defaultValue;
  };
};
export var getMixin = function getMixin(props) {
  var _ref = props || {},
    mx = _ref.mx,
    my = _ref.my,
    mb = _ref.mb,
    mr = _ref.mr,
    ml = _ref.ml,
    mt = _ref.mt,
    px = _ref.px,
    py = _ref.py,
    pb = _ref.pb,
    pr = _ref.pr,
    pl = _ref.pl,
    pt = _ref.pt,
    others = _objectWithoutPropertiesLoose(_ref, _excluded);
  var margins = {
    mx: mx,
    my: my,
    mb: mb,
    mr: mr,
    ml: ml,
    mt: mt
  };
  var paddings = {
    px: px,
    py: py,
    pb: pb,
    pr: pr,
    pl: pl,
    pt: pt
  };
  return {
    margins: margins,
    paddings: paddings,
    others: others
  };
};
export var marginMixin = css(["margin-left:", ";margin-right:", ";margin-top:", ";margin-bottom:", ";"], function (props) {
  return margins[props.mx || props.ml] || props.mx || props.ml;
}, function (props) {
  return margins[props.mx || props.mr] || props.mx || props.mr;
}, function (props) {
  return margins[props.my || props.mt] || props.my || props.mt;
}, function (props) {
  return margins[props.my || props.mb] || props.my || props.mb;
});
export var paddingMixin = css(["padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";"], function (props) {
  return paddings[props.px || props.pl] || props.px || props.pl;
}, function (props) {
  return paddings[props.px || props.pr] || props.px || props.pr;
}, function (props) {
  return paddings[props.py || props.pt] || props.py || props.pt;
}, function (props) {
  return paddings[props.py || props.pb] || props.py || props.pb;
});
export var rgba = function rgba(color, alpha) {
  var c = colors[color] || color;
  if (!c || c.length !== 7 || c[0] !== '#') return c;
  var r = parseInt(c.slice(1, 3), 16);
  var g = parseInt(c.slice(3, 5), 16);
  var b = parseInt(c.slice(5, 7), 16);
  return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
};
//# sourceMappingURL=utils.js.map